import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import SmallCaps from "./SmallCaps";

function RadioButtonInner({ active, label }) {
  return (
    <Box display="flex" alignItems="center">
      <Box
        height={24}
        width={24}
        borderRadius="100%"
        border="1px solid black"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mr="9px"
        flexShrink={0}
      >
        <Box
          height={16}
          width={16}
          borderRadius="100%"
          bg="black"
          opacity={active ? 1 : 0}
        />
      </Box>
      <SmallCaps>{label}</SmallCaps>
    </Box>
  );
}

export default RadioButtonInner;

RadioButtonInner.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};
